import { useNavigate } from 'react-router-dom';

import { TableContainer, TableHeader, SearchForm, SearchFormProps } from '@occc-app/design-system';
import { Offer_Engagement_Type } from '@occc/graphql';
import { useGetAwardsList } from '@occc-app/dataAccessLayer/award/queries';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { useSearchParams } from '@occc-app/hooks/useSearchParams';
import { useChainId } from '@occc-app/Chain/hooks';

import { AwardCatalogTable } from './AwardCatalogTable';

import { messages } from '../messages';

export const AwardCatalogTableContainer = () => {
  const navigate = useNavigate();
  const chainId = useChainId();

  const [search, setSearch] = useSearchParams();
  const [paginationInfo, onPageChange] = usePaginationParams();

  const { loading, error, data, paginationProps } = useGetAwardsList({
    filter: {
      engagementTypeIncludes: [
        Offer_Engagement_Type.Vouchered,
        Offer_Engagement_Type.SweepstakesEntry,
        Offer_Engagement_Type.FuelRollback,
      ],
      deleted: false,
      chainIdEquals: chainId,
      search,
    },
    paginationInfo,
    onPageChange,
  });

  const push = (url: string) => navigate(url);

  const onSearch: SearchFormProps['onSubmit'] = ({ search }) => {
    setSearch(search);
  };

  return (
    <TableContainer>
      <TableHeader
        title={messages.title}
        actions={<SearchForm onSubmit={onSearch} initialValues={{ search }} />}
      />
      <AwardCatalogTable
        awards={data}
        loading={loading}
        error={error}
        paginationProps={paginationProps}
        push={push}
      />
    </TableContainer>
  );
};
